import { ChangeDetectionStrategy, Component, ContentChild, Input } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TemplateDirective } from '../../directives/template.directive';
import { NgTemplateOutlet } from '@angular/common';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'cv-information-entity',
  standalone: true,
  imports: [NgTemplateOutlet, TooltipModule],
  styleUrl: './information-entity.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <article class="info-entity">
      <h6 class="info-entity__label mb-3">
        {{ label }}
        @if (value && isCopiable) {
          <span tabindex="1" class="pi pi-copy" (keydown.enter)="onCopy(value)" (click)="onCopy(value)"></span>
        }
      </h6>

      @if (content?.getType() === 'content') {
        <ng-container [ngTemplateOutlet]="content!.templateRef"></ng-container>
      } @else {
        <p class="info-entity__content">
          {{ value || 'Unknown' }}

          @if (tooltip) {
            <span class="pi pi-info-circle info-entity__tooltip-icon" [pTooltip]="tooltip"></span>
          }
        </p>
      }
    </article>
  `,
})
export class InformationEntityComponent {
  @Input() label: string = '';
  @Input({ transform: trimSting }) value: string | number | null = '';
  @Input() isCopiable: boolean = false;
  @Input() tooltip: string = '';
  @ContentChild(TemplateDirective) content: TemplateDirective | null = null;

  constructor(private readonly toastService: MessageService) {}

  async onCopy(value: string | number): Promise<void> {
    await navigator.clipboard.writeText(String(value));
    this.toastService.add({
      severity: 'success',
      summary: 'Copied',
      detail: `${this.label} is copied to clipboard`,
    });
  }
}

function trimSting(value: string | number | null): string | number | null {
  return typeof value === 'string' ? value.trim() : value;
}
